import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Chip, Typography } from "@mui/material";

export default function GalleryList() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const load = () => api.get("/sk12_gallerymst").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    const apiid = crypto.randomUUID();
    await api.post("/sk12_gallerymst", {
      apiid, Title: "Untitled Gallery", Slug: `untitled-${Date.now()}`, IsPublished: false, SortOrder: 0,
    });
    navigate(`/admin/galleries/${apiid}`);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5">Galleries</Typography>
        <Button variant="contained" onClick={create}>New Gallery</Button>
      </Box>
      <Table>
        <TableHead>
          <TableRow><TableCell>Title</TableCell><TableCell>Slug</TableCell><TableCell>Status</TableCell></TableRow>
        </TableHead>
        <TableBody>
          {rows.map((g) => (
            <TableRow key={g.apiid} hover sx={{ cursor: "pointer" }} onClick={() => navigate(`/admin/galleries/${g.apiid}`)}>
              <TableCell>{g.Title}</TableCell>
              <TableCell>{g.Slug}</TableCell>
              <TableCell>
                <Chip size="small" color={g.IsPublished ? "success" : "default"} label={g.IsPublished ? "Published" : "Draft"} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
